<template>
    <v-container class="container" fluid>
        <v-card>
            <v-form>
                <v-system-bar height="70px" dark color="secondary">
                    <v-spacer></v-spacer>
                    <v-toolbar-title class="white--text"
                        >Activity Log
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-system-bar>
            </v-form>

            <v-card-title>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-row justify="center">
                    <v-col cols="4">
                        <v-text-field
                            id="start_date"
                            label="Start Date"
                            placeholder="YYYY-MM-DD"
                            v-mask="'####-##-##'"
                            type="tel"
                            :value="start_date"
                            :rules="dateRules"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                        <v-text-field
                            id="end_date"
                            label="End Date"
                            placeholder="YYYY-MM-DD"
                            v-mask="'####-##-##'"
                            type="tel"
                            :value="end_date"
                            :rules="dateRules"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="1">
                        <v-btn
                            color="secondary"
                            small
                            @click="getActivityLog()"
                        >
                            View
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>

            <v-data-table
                :headers="headers"
                :items="Logs"
                class="mx-4"
                :search="search"
            >
                <template v-slot:item.actions="{ item }">
                    <v-icon small class="mx-3" @click="openModal(item)"
                        >mdi-eye-outline</v-icon
                    >
                    <!-- <v-icon small @click="deleteItem(item)">mdi-delete</v-icon> -->
                </template>
            </v-data-table>
        </v-card>
        <v-dialog
            v-model="dialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Log detail</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-container fluid>
                    <v-row>
                        <v-col cols="2">
                            <v-text-field
                                v-model="log.id"
                                label="Log ID"
                            ></v-text-field>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="4">
                            <v-text-field
                                label="Date"
                                v-model="log.created_at"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">
                            <v-text-field
                                v-model="log.causer.name"
                                label="User"
                            ></v-text-field>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="3">
                            <v-text-field
                                label="Type"
                                v-model="log.description"
                            ></v-text-field>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="3">
                            <v-text-field
                                label="Event"
                                v-model="log.log_name"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
                <v-container fluid>
                    <v-toolbar-title>Changes</v-toolbar-title>
                    <v-row cols="12">
                        <v-col cols="5">
                            <v-textarea v-model="log.old"></v-textarea>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="5">
                            <v-textarea v-model="log.new"></v-textarea>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';
export default {
    directives: { mask },
    data: function() {
        return {
            users: [],
            activityTypes: [],
            search: '',
            start_date: '',
            end_date: '',
            log: {
                id: '',
                created_at: '',
                description: '',
                causer: { name: '' },
                log_name: '',
                subject: ''
            },
            Logs: [],
            dialog: false,
            headers: [
                {
                    text: 'User',
                    align: 'start',
                    sortable: false,
                    value: 'causer.name'
                },
                {
                    text: 'Activity type',
                    value: 'description'
                },
                { text: 'Area', value: 'log_name' },
                { text: 'Date', value: 'created_at' },
                {
                    text: 'Actions',
                    value: 'actions',
                    sortable: false
                }
            ],
            dateRules: [
                v => !!v || 'This date is required',
                v =>
                    (parseInt(v[5] + v[6]) <= 12 &&
                        parseInt(v[5] + v[6]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[8] + v[9]) <= 31 &&
                        parseInt(v[8] + v[9]) > 0) ||
                    'Date Incorrect'
            ]
        };
    },
    methods: {
        getActivityLog: function() {
            this.$store.state.isLoading = true;
            var start = this.getMsk('start_date');
            var end = this.getMsk('end_date');
            if (start != '' && end != '') {
                axios
                    .get('/get-log/' + start + '/' + end, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        this.Logs = response.data;
                        console.log(this.Logs);
                        for (let i = 0; i < this.Logs.length; i++) {
                            if (this.Logs[i].created_at != null)
                                this.Logs[i].created_at = new Date(
                                    this.Logs[i].created_at
                                ).toLocaleString();
                        }
                        console.log(this.Logs);
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            }

            this.$store.state.isLoading = false;
        },

        loadUsers() {
            var a = [];
            for (let i = 0; i < this.Logs.length; i++) {
                if (this.Logs[i].causer != null)
                    a.push(this.Logs[i].causer.name);
            }
            this.users = a.filter(function(item, pos, self) {
                return self.indexOf(item) == pos;
            });
            console.log(this.users);
        },

        loadActivityTypes() {
            var a = [];
            for (let i = 0; i < this.Logs.length; i++) {
                if (this.Logs[i].log_name != null)
                    a.push(this.Logs[i].log_name);
            }
            this.activityTypes = a.filter(function(item, pos, self) {
                return self.indexOf(item) == pos;
            });
            console.log(this.activityTypes);
        },
        getMsk: function(id) {
            return document.getElementById(id).value;
        },
        openModal(item) {
            this.log = item;
            if (item.properties.old != null)
                this.log.old = JSON.stringify(item.properties.old);
            else this.log.old = '';

            this.log.new = JSON.stringify(item.properties.attributes);
            this.dialog = true;
            console.log(this.log);
        }
    }
};
</script>
